import { Loader } from '@/modules/base/classes/loaders'
import { HexCode } from '@/modules/kisweui/types'

// NOTE: UI allows weight/saturation to be a value between 1-100. Setting it to 0 (zero) will signal the backend to
// disable the ChromaKey altogether.

export default class ChromaKey {
  enabled: boolean = false
  /** @deprecated use 'color' instead */
  screen: HexCode = '#20AA20FF'
  /** @deprecated use 'brightness' instead */
  balance: number = 20
  /** @deprecated use 'saturation' instead */
  weight: number = 10
  /** @deprecated use 'threshold[0]' instead */
  clipblack: number = 30
  /** @deprecated use 'threshold[1]' instead */
  clipwhite: number = 80

  constructor (data?: unknown) {
    if (!data) return
    this.enabled = Loader.loadBoolean(data, 'enabled', this.enabled)
    this.screen = Loader.loadHexCode(data, 'screen', this.screen)
    this.balance = Loader.loadNumber(data, 'balance', this.balance)
    this.clipblack = Loader.loadNumber(data, 'clipblack', this.clipblack)
    this.clipwhite = Loader.loadNumber(data, 'clipwhite', this.clipwhite)
    this.weight = Loader.loadNumber(data, 'weight', this.weight)
  }

  get color (): HexCode {
    return this.screen
  }

  set color (newVal: HexCode) {
    this.screen = newVal
  }

  get brightness (): number {
    return this.balance
  }

  set brightness (newVal: number) {
    this.balance = newVal
  }

  get saturation (): number {
    return this.weight
  }

  set saturation (newVal: number) {
    this.weight = newVal
  }

  get threshold (): [number, number] {
    return [this.clipblack, this.clipwhite]
  }

  set threshold (newVal: [number, number]) {
    const threshold = newVal.sort((a, b) => a - b)
    this.clipblack = threshold[0]
    this.clipwhite = threshold[1]
  }

}
